import React from 'react';
import { OptionType } from '@ru-digital-assets/ui-component/dist/stories/ui/ui-select/ui-select';
import FormFooter from '../../../containers/form-footer';
import GoBack from '../../../containers/go-back';
import IconBtn from '../../../modules/icon-btn/icon-btn';
import UiSelect from '../../../modules/ui/ui-select/ui-select';
import SignIcon from './SignIcon.svg';

interface UcpSignFormProps {
  certsList: { value: string; label: string }[];
  onSubmit: () => void;
  disabled: boolean;
  selected: OptionType | undefined;
  onCertSelect: (certificate: OptionType | OptionType[] | undefined) => void;
  backCallback: () => void;
  btnText?: string;
}

const UcpSignForm: React.FC<UcpSignFormProps> = ({
  certsList,
  selected,
  onCertSelect,
  btnText,
  disabled,
  backCallback,
  onSubmit,
}) => {
  return (
    <FormFooter>
      <form className="ucp__form form-assets__container form-asset-credit__container">
        <div className="footer__go-back">
          <GoBack onClick={backCallback} />
        </div>
        <div className="form-assets__flex">
          <div className="form-assets__item form-assets__item-432  form-assets__item--select">
            <UiSelect
              label="Выберите подпись:"
              value={selected}
              options={certsList}
              lg
              onChange={onCertSelect}
            />
          </div>
        </div>
        <div className="form-assets__item">
          <div className="form-item">
            <IconBtn
              onClick={onSubmit}
              disabled={disabled}
              lg
              icon={SignIcon}
              title={btnText ? btnText : 'Подписать'}
            />
          </div>
        </div>
      </form>
    </FormFooter>
  );
};

export default UcpSignForm;
